import { mapState } from 'pinia';
import useAuthStore from '@/common/store/pinia/auth';
import { mapGetters } from 'vuex';
import usePostMessage from '@/common/composables/usePostMessage';

const PROHIBIT_REDIRECT_URL = ['/', '/users', '/access-disabled'];
const { sendPostMessage } = usePostMessage();

export default {
  data() {
    return {
      pending: false
    };
  },
  computed: {
    ...mapState(useAuthStore, ['isLoggingIn', 'currentUser', 'currentProject']),
    ...mapGetters({
      projects: 'projects/getItems'
    }),
    isSigningIn() {
      return this.isLoggingIn || this.pending;
    }
  },
  watch: {
    currentUser: {
      immediate: true,
      handler(value, prevValue) {
        if (value === prevValue) {
          return;
        }
        if (value) {
          sendPostMessage('authSuccess');
          this.afterLoginRedirect();
        } else {
          sendPostMessage('logout');
        }
      }
    }
  },
  methods: {
    sendPostMessage,
    getLandingPage() {
      return Promise.resolve();
    },
    async afterLoginRedirect() {
      this.pending = true;
      if (this.$route.query.project_id && this.$route.query.project_id !== this.currentUser.project_id) {
        await this.authStore.signInProject(this.$route.query.project_id);
      }
      if (this.$route.query.redirectUrl && !PROHIBIT_REDIRECT_URL.includes(this.$route.query.redirectUrl)) {
        return this.$router.push(this.$route.query.redirectUrl);
      }
      const landingPage = await this.getLandingPage();
      return this.$router.push({ name: landingPage });
    },
  }
};
